import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Parse from "parse";
import { useGame } from "../header/GameContext";
import Header from "../header/header";
import { saveToSheet } from "../../api/sheet";
import { hasSurveyRow } from "../../api/surveyApi";
import "./clear.css";

const formatTime = (seconds) => {
  if (seconds == null || isNaN(seconds) || seconds <= 0) return "-";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}분 ${s < 10 ? "0" : ""}${s}초`;
};

export default function Clear({ timerMode = "pause" }) {
  const navigate = useNavigate();
  const { state } = useLocation();

  const {
    time,
    playerName,
    playerKeyCode,
    startTimer,
    pauseTimer,
    TOTAL_GAME_TIME,
    correctCount,
  } = useGame();

  const [hasSurvey, setHasSurvey] = useState(false);

  const userId = localStorage.getItem("gameUserId");

  /* 점수 */
  const finalQuizScore = Math.round((correctCount / 6) * 100);
  const TotalQuizScore = finalQuizScore;

  /* 타이머 제어 */
  useEffect(() => {
    timerMode === "run" ? startTimer() : pauseTimer();
  }, [timerMode, startTimer, pauseTimer]);

  const displayName = playerName;

  /* =========================
     ✅ 클리어 시간 — localStorage 기준
     ADMIN_TIME_KEY = 관리자 설정 원래값
     GAME_TIME_REMAIN = 마지막 남은시간
  ========================= */
  const adminTime =
    Number(localStorage.getItem("ADMIN_TIME_KEY")) ||
    Number(TOTAL_GAME_TIME) ||
    0;
  const remainTime =
    Number(localStorage.getItem("GAME_TIME_REMAIN")) || Number(time) || 0;
  const usedTime = adminTime - remainTime;

  const escapeTime = formatTime(usedTime);

  /* 날짜 */
  const today = new Date();
  const dateText = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

  /* =========================
     DB 저장 (최초 1회, 직접 접속 시만)
  ========================= */
  const savedRef = useRef(false);

  useEffect(() => {
    if (savedRef.current) return;

    const keyCode = playerKeyCode || localStorage.getItem("PLAYER_KEY_CODE");
    const userId = localStorage.getItem("gameUserId");

    if (!keyCode && !userId) {
      console.error("❌ keyCode, userId 모두 없음");
      return;
    }

    const saveClearTime = async () => {
      try {
        const GameUser = Parse.Object.extend("silence1");
        let user = null;

        if (keyCode) {
          const q = new Parse.Query(GameUser);
          q.equalTo("keyCode", keyCode);
          user = await q.first();
        }
        if (!user && userId) {
          const q = new Parse.Query(GameUser);
          user = await q.get(userId).catch(() => null);
        }
        if (!user) {
          console.error("❌ 유저를 찾을 수 없음");
          return;
        }

        user.set("clearTime", usedTime);
        user.set("score", finalQuizScore);
        await user.save();
        savedRef.current = true;
        console.log("✅ 클리어 DB 저장 완료 - usedTime:", usedTime);

        try {
          await saveToSheet({
            keyCode: keyCode || userId,
            score: finalQuizScore,
            clearTime: escapeTime,
          });
        } catch (sheetError) {
          console.error("시트 저장 실패:", sheetError.message);
        }
      } catch (e) {
        console.error("❌ 클리어 DB 저장 실패", e);
      }
    };

    saveClearTime();
  }, [playerKeyCode]);

  // 설문 참여 여부 확인
  useEffect(() => {
    const checkSurvey = async () => {
      const result = await hasSurveyRow(userId);

      setHasSurvey(result);
    };

    if (userId) {
      checkSurvey();
    }
  }, [userId]);

  return (
    <div id="content">
      <Header isFinalQuiz={true} />

      <div className={`box content_box1 ans0001 clearBox`}>
        <div className="box_con con_box1 con_pd5 con_box_c">
          <div className="mission_tit clearTit"></div>

          <p className="clearBT mt40">방탈출 성공!</p>

          <div className="clearInfoBox mt40">
            <p className="clearBTxt">클리어 시간: {escapeTime}</p>
            <p className="clearBTxt">최종 점수: {TotalQuizScore}점 / 100점</p>

            <p className="clearSTxt mt16">[90-100점] 완벽한 명탐정!</p>
            <p className="clearSTxt">[70-89점] 수사관</p>
            <p className="clearSTxt">[50-69점] 인턴 요원</p>
            <p className="clearSTxt">[0-49점] 미로에 갇힌 자</p>

            <p className="clearTxt mt24">방탈출에 성공했음을 인증합니다.</p>
          </div>

          <div id="box_ft">
            <button
              type="button"
              className="inputBtn02 btnCode mt16"
              onClick={() => navigate("/ranking")}
            >
              랭킹 확인하기
            </button>
            <button
              type="button"
              className="inputBtn02 btnCode mt16"
              onClick={() => {
                if (hasSurvey) {
                  alert("이미 설문조사에 참여하셨습니다.");
                  return;
                }

                navigate("/survey/1");
              }}
            >
              체험 의견 전달하기
            </button>
            <p className="nextFlowInfo mt16">
              *설문은 오늘 프로그램에 대한 의견을
              <br />
              듣기 위해 마련되었습니다.
              <br />
              응답 내용은 향후 프로그램 개선을 위한
              <br />
              기초 자료로 활용됩니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
